module.exports = __webpack_public_path__ + "static/media/cont1401.f8563df.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1401.mp4
// module id = 7hwd
// module chunks = 0